import React from "react";
import { Image } from "react-bootstrap";
import "./aboutUsMiniCard.style.scss";

const AboutUsMiniCard = ({ title, imageUrl, onClick, type }) => {
	return (
		<div className="about-us-mini-card" onClick={onClick}>
			<Image
				src={imageUrl.default ? imageUrl.default : imageUrl}
				alt={title}
				className="about-us-mini-card--image"
			/>
			<div className="about-us-mini-card--title">
				<h6 style={{ fontSize: "15px" }}>{title}</h6>
			</div>
		</div>
	);
};

export default AboutUsMiniCard;
